import { post } from "@utils/httpUtil";

// 分页查询特色项目管理列表
export function specialProjectPageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/specialProject/pageList`, data, config);
}
// 查询特色项目详情
export function specialProjectFindeById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/specialProject/findById`, data, config);
}
// 新建特色项目
export function specialProjectSaveOrUpdate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/specialProject/saveOrUpdate`, data, config);
}
// 查询特色项目专栏开关
export function specialProjectGetConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/specialProject/getConfig`, data, config);
}
// 开启/关闭特色项目专栏
export function specialProjectUpdateConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/specialProject/updateConfig`, data, config);
}
// 删除特色项目
export function specialProjectDeleteById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/specialProject/deleteById`, data, config);
}
// 列表显示/隐藏精彩活动
export function specialProjectShowStatusById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/specialProject/showStatusById`, data, config);
}
// 上下架项目
export function specialProjectShelfStatusById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/specialProject/shelfStatusById`, data, config);
}
